import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { v4 as uuidv4 } from 'uuid';

@Component({
    selector: 'rttd-length-restricted-textarea',
    templateUrl: './length-restricted-textarea.component.html',
    styles: [
        require('./length-restricted-textarea.component.scss').default.toString(),
        require(`./length-restricted-textarea.component.${environment.brand}.scss`).default.toString()
    ]
})
export class LengthRestrictedTextareaComponent implements OnInit {

    @Input() maxLength: number;
    @Input() prefill: string;
    @Input() title: string;
    @Input() placeholder: string;
    @Output() output = new EventEmitter<string>();
    userText = '';

    /** UUID's
     * @description To allow this textarea to be used in multiple times in a single page,
     * it needs unique strings 'id' and 'for'
     */
    uuid = uuidv4();

    constructor() {
    }

    ngOnInit() {
        if (this.prefill) {
            this.userText = this.prefill;
        }
    }

    update() {
        this.output.emit(this.userText);
    }
}
